import { format, formatDistanceToNow } from 'date-fns'
import { uk, enUS, ru } from 'date-fns/locale'
import i18n from '../i18n'

const getLocale = () => {
  switch (i18n.language) {
    case 'uk':
      return uk
    case 'ru':
      return ru
    case 'en':
      return enUS
    default:
      return uk
  }
}

export function getRelativeTime(date: string) {
  return formatDistanceToNow(new Date(date), { addSuffix: true, locale: getLocale() })
}

// One date format on every page, whatever the browser language:
// toLocaleDateString() printed "9/24/2026" in an English browser next to
// "24.09.2026" elsewhere.
export function formatDate(date: string | Date) {
  return format(new Date(date), 'dd.MM.yyyy')
}

export function formatDateTime(date: string | Date) {
  return format(new Date(date), 'dd.MM.yyyy, HH:mm')
}

export function getShortTime(date: string) {
  return format(new Date(date), 'HH:mm') // Формат "24-часовой:минуты"
}
